import type { CSSProperties, ReactNode } from 'react';

interface PanelProps {
  title?: string;
  actions?: ReactNode;
  children: ReactNode;
  flush?: boolean;
  className?: string;
  style?: CSSProperties;
}

export function Panel({ title, actions, children, flush, className, style }: PanelProps) {
  return (
    <section className={`panel${className ? ` ${className}` : ''}`} style={style}>
      {(title || actions) && (
        <header className="panel__header">
          {title && <h3 className="panel__title">{title}</h3>}
          {actions && <div className="panel__actions">{actions}</div>}
        </header>
      )}
      <div className={`panel__body${flush ? ' panel__body--flush' : ''}`}>{children}</div>
    </section>
  );
}
